export const API_BASE_URL = process.env.API_BASE_URL ?? "";